/**
 * DecalYard - Build Your Own Custom Sticker Sheet
 * Pricing calculator with Shopify variant switching, file upload, and add-to-cart
 * No external dependencies
 *
 * VARIANT SETUP:
 * This script expects the product to have variants named in this format:
 *   Option 1 (Sheet Size): "4x6" or "8.5x11"
 *   Option 2 (Quantity):   "50", "100", "250", "500", "1000", "2500", "5000"
 *
 * The variant prices in Shopify should include the $49 setup fee baked in.
 * See the VARIANT_PRICES object below for the expected totals.
 */

(function () {
  'use strict';

  var SETUP_FEE = 49.00;

  /* Base print prices BEFORE setup fee */
  var PRINT_PRICES = {
    '4x6': {
      50: 115.00,
      100: 175.00,
      250: 345.00,
      500: 540.00,
      1000: 925.00,
      2500: 2750.00,
      5000: 3275.00
    },
    '8.5x11': {
      50: 275.00,
      100: 435.00,
      250: 875.00,
      500: 1505.00,
      1000: 2625.00,
      2500: 3750.00,
      5000: 10965.00
    }
  };

  var TIERS = [50, 100, 250, 500, 1000, 2500, 5000];
  var MAX_FILES = 10;
  var MAX_FILE_SIZE = 25 * 1024 * 1024;
  var ACCEPTED_EXTENSIONS = ['png', 'jpg', 'jpeg', 'pdf', 'ai', 'eps', 'svg'];

  /*
   * variantMap is populated from the Liquid-rendered JSON in the page.
   * Structure: { "4x6|50": 12345678, "8.5x11|100": 23456789, ... }
   * Where the value is the Shopify variant ID.
   */
  var variantMap = {};

  var state = {
    size: null,
    quantity: null,
    customQuantity: null,
    isCustomQty: false,
    finish: 'Gloss',
    files: [],
    validVariant: false
  };

  function init() {
    loadVariantMap();
    bindSizeCards();
    bindQuantityButtons();
    bindCustomQuantity();
    bindFinishButtons();
    bindFileUpload();
    bindAddToCart();
    updateSummary();
  }

  // --- VARIANT MAP ---

  function loadVariantMap() {
    var el = document.getElementById('css-variant-data');
    if (!el) return;
    try {
      var raw = JSON.parse(el.textContent);
      /* Normalize keys: trim whitespace and ensure consistent format */
      var keys = Object.keys(raw);
      for (var i = 0; i < keys.length; i++) {
        var normalized = keys[i].replace(/\s/g, '').trim();
        variantMap[normalized] = raw[keys[i]];
      }
    } catch (e) {
      variantMap = {};
    }
  }

  function getVariantId(size, quantity) {
    var key = String(size).replace(/\s/g, '') + '|' + String(quantity).replace(/\s/g, '');
    return variantMap[key] || null;
  }

  function findNearestHigherTier(quantity) {
    for (var i = 0; i < TIERS.length; i++) {
      if (TIERS[i] >= quantity) return TIERS[i];
    }
    return TIERS[TIERS.length - 1];
  }

  function updateHiddenVariantId(variantId) {
    var input = document.querySelector('#css-product-form [name="id"]');
    if (input && variantId) {
      input.value = variantId;
    }
  }

  // --- SIZE SELECTION ---

  function bindSizeCards() {
    var cards = document.querySelectorAll('[data-size-card]');
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        state.size = card.getAttribute('data-size-card');
        cards.forEach(function (c) { c.classList.remove('css-card--selected'); });
        card.classList.add('css-card--selected');
        recalculate();
      });
    });
  }

  // --- QUANTITY SELECTION ---

  function bindQuantityButtons() {
    var buttons = document.querySelectorAll('[data-qty-btn]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var qty = parseInt(btn.getAttribute('data-qty-btn'), 10);
        state.quantity = qty;
        state.customQuantity = null;
        state.isCustomQty = false;
        var customInput = document.getElementById('css-custom-qty');
        if (customInput) customInput.value = '';
        clearCustomError();
        buttons.forEach(function (b) { b.classList.remove('css-qty-btn--selected'); });
        btn.classList.add('css-qty-btn--selected');
        recalculate();
      });
    });
  }

  function bindCustomQuantity() {
    var input = document.getElementById('css-custom-qty');
    if (!input) return;

    var debounceTimer;
    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        var val = parseInt(input.value, 10);
        clearCustomError();

        if (isNaN(val) || input.value.trim() === '') {
          state.customQuantity = null;
          state.quantity = null;
          state.isCustomQty = false;
          clearQuantitySelection();
          recalculate();
          return;
        }

        if (val < 50) {
          showCustomError('Minimum order is 50 sheets');
          state.customQuantity = null;
          state.quantity = null;
          state.isCustomQty = false;
          clearQuantitySelection();
          recalculate();
          return;
        }

        state.customQuantity = val;
        state.quantity = val;
        state.isCustomQty = true;
        clearQuantitySelection();
        recalculate();
      }, 300);
    });
  }

  function clearQuantitySelection() {
    var buttons = document.querySelectorAll('[data-qty-btn]');
    buttons.forEach(function (b) { b.classList.remove('css-qty-btn--selected'); });
  }

  function showCustomError(msg) {
    var el = document.getElementById('css-custom-qty-error');
    if (el) {
      el.textContent = msg;
      el.style.display = 'block';
    }
  }

  function clearCustomError() {
    var el = document.getElementById('css-custom-qty-error');
    if (el) {
      el.textContent = '';
      el.style.display = 'none';
    }
  }

  // --- FINISH SELECTION ---

  function bindFinishButtons() {
    var buttons = document.querySelectorAll('[data-finish-btn]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.finish = btn.getAttribute('data-finish-btn');
        buttons.forEach(function (b) { b.classList.remove('css-finish-btn--selected'); });
        btn.classList.add('css-finish-btn--selected');
        updateSummary();
      });
    });
  }

  // --- PRICING ---

  function calculatePrintPrice(size, quantity) {
    if (!size || !quantity) return null;

    var prices = PRINT_PRICES[size];
    if (!prices) return null;

    if (prices[quantity] !== undefined) {
      return prices[quantity];
    }

    if (quantity < 50) return null;

    if (quantity > 5000) {
      var ratePerSheet = prices[5000] / 5000;
      return Math.round(ratePerSheet * quantity * 100) / 100;
    }

    var lowerTier = null;
    var upperTier = null;

    for (var i = 0; i < TIERS.length - 1; i++) {
      if (quantity >= TIERS[i] && quantity <= TIERS[i + 1]) {
        lowerTier = TIERS[i];
        upperTier = TIERS[i + 1];
        break;
      }
    }

    if (lowerTier === null || upperTier === null) return null;

    var lowerPrice = prices[lowerTier];
    var upperPrice = prices[upperTier];
    var fraction = (quantity - lowerTier) / (upperTier - lowerTier);
    var interpolated = lowerPrice + (fraction * (upperPrice - lowerPrice));

    return Math.round(interpolated * 100) / 100;
  }

  function isStandardTier(quantity) {
    return TIERS.indexOf(quantity) !== -1;
  }

  function recalculate() {
    state.validVariant = false;

    if (state.size && state.quantity) {
      var variantId;
      if (state.isCustomQty) {
        /* Custom quantity: use nearest higher tier variant */
        var nearestTier = findNearestHigherTier(state.quantity);
        variantId = getVariantId(state.size, nearestTier);
      } else {
        /* Standard tier: exact match */
        variantId = getVariantId(state.size, state.quantity);
      }

      if (variantId) {
        updateHiddenVariantId(variantId);
        state.validVariant = true;
      }
    }
    updateSummary();
  }

  function formatCurrency(amount) {
    return '$' + amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function updateSummary() {
    var sizeEl = document.getElementById('css-summary-size');
    var qtyEl = document.getElementById('css-summary-qty');
    var finishEl = document.getElementById('css-summary-finish');
    var setupEl = document.getElementById('css-summary-setup');
    var subtotalEl = document.getElementById('css-summary-subtotal');
    var totalEl = document.getElementById('css-summary-total');
    var addBtn = document.getElementById('css-add-to-cart');
    var customNoteEl = document.getElementById('css-custom-qty-note');

    var sizeLabel = '';
    if (state.size === '4x6') sizeLabel = '4 x 6 inch';
    if (state.size === '8.5x11') sizeLabel = '8.5 x 11 inch';

    if (sizeEl) sizeEl.textContent = sizeLabel || '--';
    if (qtyEl) qtyEl.textContent = state.quantity || '--';
    if (finishEl) finishEl.textContent = state.finish;
    if (setupEl) setupEl.textContent = formatCurrency(SETUP_FEE);

    var printPrice = calculatePrintPrice(state.size, state.quantity);

    if (printPrice !== null && state.validVariant) {
      var total = printPrice + SETUP_FEE;
      if (subtotalEl) subtotalEl.textContent = formatCurrency(printPrice);
      if (totalEl) totalEl.textContent = formatCurrency(total);
      if (addBtn) addBtn.disabled = false;

      /* Show note for custom quantities */
      if (customNoteEl) {
        if (state.isCustomQty) {
          customNoteEl.textContent = 'Custom quantity - final price adjusted before fulfillment.';
          customNoteEl.style.display = 'block';
        } else {
          customNoteEl.style.display = 'none';
        }
      }
    } else {
      if (subtotalEl) subtotalEl.textContent = '--';
      if (totalEl) totalEl.textContent = '--';
      if (addBtn) addBtn.disabled = true;
      if (customNoteEl) customNoteEl.style.display = 'none';
    }

    var mobileTotal = document.getElementById('css-mobile-total');
    if (mobileTotal) {
      mobileTotal.textContent = printPrice !== null ? formatCurrency(printPrice + SETUP_FEE) : '--';
    }
  }

  // --- FILE UPLOAD ---

  function bindFileUpload() {
    var dropzone = document.getElementById('css-dropzone');
    var fileInput = document.getElementById('css-file-input');
    if (!dropzone || !fileInput) return;

    dropzone.addEventListener('click', function () {
      fileInput.click();
    });

    dropzone.addEventListener('dragover', function (e) {
      e.preventDefault();
      dropzone.classList.add('css-dropzone--active');
    });

    dropzone.addEventListener('dragleave', function () {
      dropzone.classList.remove('css-dropzone--active');
    });

    dropzone.addEventListener('drop', function (e) {
      e.preventDefault();
      dropzone.classList.remove('css-dropzone--active');
      handleFiles(e.dataTransfer.files);
    });

    fileInput.addEventListener('change', function () {
      handleFiles(fileInput.files);
      fileInput.value = '';
    });
  }

  function handleFiles(fileList) {
    var files = Array.prototype.slice.call(fileList);
    clearUploadError();

    if (state.files.length + files.length > MAX_FILES) {
      if (files.length > 1) {
        showUploadError('Too many files. Please upload fewer design files and try again.');
      } else {
        showUploadError("You've reached the maximum number of design files for this order. Remove a file to add a new one.");
      }
      return;
    }

    for (var i = 0; i < files.length; i++) {
      var file = files[i];
      var ext = file.name.split('.').pop().toLowerCase();

      if (ACCEPTED_EXTENSIONS.indexOf(ext) === -1) {
        showUploadError('File "' + file.name + '" is not a supported format. Use PNG, JPG, PDF, AI, EPS, or SVG.');
        continue;
      }

      if (file.size > MAX_FILE_SIZE) {
        showUploadError('File "' + file.name + '" exceeds the 25MB size limit.');
        continue;
      }

      state.files.push({
        name: file.name,
        size: file.size,
        file: file
      });
    }

    renderFileList();
  }

  function removeFile(index) {
    state.files.splice(index, 1);
    clearUploadError();
    renderFileList();
  }

  function renderFileList() {
    var listEl = document.getElementById('css-file-list');
    if (!listEl) return;

    if (state.files.length === 0) {
      listEl.innerHTML = '';
      return;
    }

    var html = '';
    for (var i = 0; i < state.files.length; i++) {
      var f = state.files[i];
      var sizeKB = Math.round(f.size / 1024);
      var sizeStr = sizeKB > 1024 ? (sizeKB / 1024).toFixed(1) + ' MB' : sizeKB + ' KB';
      html += '<div class="css-file-item">';
      html += '<span class="css-file-name">' + escapeHtml(f.name) + ' <span class="css-file-size">(' + sizeStr + ')</span></span>';
      html += '<button type="button" class="css-file-remove" data-remove-index="' + i + '" aria-label="Remove ' + escapeHtml(f.name) + '">X</button>';
      html += '</div>';
    }

    listEl.innerHTML = html;

    var removeButtons = listEl.querySelectorAll('[data-remove-index]');
    removeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        removeFile(parseInt(btn.getAttribute('data-remove-index'), 10));
      });
    });
  }

  function showUploadError(msg) {
    var el = document.getElementById('css-upload-error');
    if (el) {
      el.textContent = msg;
      el.style.display = 'block';
    }
  }

  function clearUploadError() {
    var el = document.getElementById('css-upload-error');
    if (el) {
      el.textContent = '';
      el.style.display = 'none';
    }
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  // --- ADD TO CART ---

  function bindAddToCart() {
    var form = document.getElementById('css-product-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      if (!state.size || !state.quantity || !state.validVariant) return;

      var printPrice = calculatePrintPrice(state.size, state.quantity);
      if (printPrice === null) return;

      /* Verify the variant ID is set and valid */
      var variantId = form.querySelector('[name="id"]').value;
      if (!variantId || variantId === '0') {
        showUploadError('Please select a sheet size and quantity.');
        return;
      }

      var sizeLabel = state.size === '4x6' ? '4 x 6 inch' : '8.5 x 11 inch';
      var total = printPrice + SETUP_FEE;

      var fileNames = state.files.map(function (f) { return f.name; }).join(', ');

      /*
       * FILE UPLOAD INTEGRATION NOTE:
       * Shopify does not natively support file uploads on product pages.
       * Connect a file upload app or cloud storage solution here.
       * For now, file names are passed as a line item property for reference.
       */

      var properties = {
        'Sheet Size': sizeLabel,
        'Quantity': state.quantity.toString(),
        'Finish': state.finish,
        'Setup Fee': formatCurrency(SETUP_FEE),
        'Print Price': formatCurrency(printPrice),
        'Quoted Total': formatCurrency(total)
      };

      if (fileNames) {
        properties['Design Files'] = fileNames;
      }

      /* For custom quantities, add a note so the order can be adjusted before fulfillment */
      if (state.isCustomQty) {
        var nearestTier = findNearestHigherTier(state.quantity);
        properties['Order Note'] = 'Custom quantity order (' + state.quantity + ' sheets). Quoted price: ' + formatCurrency(total) + '. Cart charged at ' + nearestTier + '-sheet tier rate. Adjust final price to ' + formatCurrency(total) + ' before fulfillment.';
      }

      var body = {
        items: [{
          id: parseInt(variantId, 10),
          quantity: 1,
          properties: properties
        }]
      };

      var addBtn = document.getElementById('css-add-to-cart');
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Adding...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart error');
          return response.json();
        })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function () {
          if (addBtn) {
            addBtn.disabled = false;
            addBtn.textContent = 'Add to Cart';
          }
          showUploadError('There was a problem adding to cart. Please try again.');
        });
    });
  }

  // --- INIT ---

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
